/**
 * 课程管理
 */

import {
  get,
  post
} from '@/util/request'

/**
 * 获取课程分类
 * @param {*} data
 * @returns
 */
export const GetwXGetCourseCategoryList = (data={}) => {
  return post('/api/app/courseCategory/wXGetCourseCategoryList', data);
}

/**
 * 获取课程分页
 * @param {*} data
 * @returns
 */
export const GetwXGetDataByPageQuery = (data={}) => {
  return post('/api/app/course/wXGetDataByPageQuery', data);
}

/**
 * 获取具体的课程信息和课程章节
 * @param {*} data
 * @returns
 */
export const GetwXGetCourseDetailInfoApi = (courseId) => {
  return post(`/api/app/course/wXGetCourseDetailInfo/${courseId}`);
}

/**
 * 更新用户的浏览记录
 * @param {*} data
 * @returns
 */
export const EditModifyCourseBrowseApi = (params, data={}) => {
  return post('/api/app/course/modifyCourseBrowse', data, params);
}

/**
 * 更新章节学习时间
 * @param {*} data
 * @returns
 */
export const EditModifyWatchTimeApi = (data={}, params) => {
  return post('/api/app/course/modifyWatchTime', data, params);
}

/**
 * 获取用户课程浏览记录
 * @param {*} data
 * @returns
 */
export const GetCourseBrowseRecordsApi = (data) => {
  return get('/api/app/course/courseBrowseRecords', data);
}

/**
 * 获取用户章节学习时间
 * @param {*} data
 * @returns
 */
export const GetCourseChapterStudyTimeApi = (data) => {
  return get('/api/app/course/courseChapterStudyTime', data);
}

/**
 * 获取课程学习学习记录
 * @param {*} data
 * @returns
 */
export const GetCourseLearnRecordQueryApi = (data={}) => {
  return post('/api/app/course/getCourseLearnRecordQuery', data);
}